import { forwardRef } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// react-select components
import Select from "react-select";

import colors from "../../assest/theme/base/colors";
import styles from "./styles";

const MaterialSelect = forwardRef(
  (
    { size, error, success, customStyles, isSearchable = true, ...rest },
    ref
  ) => {
    const { gradients } = colors;
    return (
      <Select
        {...rest}
        isSearchable={isSearchable}
        ref={ref}
        styles={{
          ...styles(size, error, success, customStyles),
          menuPortal: (base) => ({ ...base, zIndex: 9999 }), // Ensures the dropdown appears on top
        }}
        menuPortalTarget={document.body} // This ensures the dropdown is rendered outside the parent
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary25: gradients.dark.state,
            primary: gradients.dark.main,
          },
        })}
      />
    );
  }
);

// Typechecking props for the MaterialSelect
MaterialSelect.propTypes = {
  size: PropTypes.oneOf(["small", "medium", "large"]),
  error: PropTypes.bool,
  success: PropTypes.bool,
  onChange: PropTypes.func,
  isSearchable: PropTypes.bool,
};

export default MaterialSelect;
